"use strict";
exports.__esModule = true;
exports.deleteFieldPermanently = exports.restoreField = exports.markFieldDeleted = exports.updateField = exports.addField = void 0;
var lodash_1 = require("lodash");
var types_1 = require("../types");
var validators_1 = require("../validation/validators");
var addField = function (fieldKey, config) {
    validators_1.validateFieldKey(fieldKey);
    validators_1.validateConfigType(config);
    validators_1.validateFieldType(config.type);
    validators_1.validateConfigProperties(config);
    return {
        op: types_1.PatchType.ADD,
        path: "/fields/" + fieldKey,
        value: config
    };
};
exports.addField = addField;
var updateField = function (fieldKey, config) {
    validators_1.validateFieldKey(fieldKey);
    validators_1.validateConfigType(config);
    validators_1.validateOptionalFieldType(config.type);
    validators_1.validateConfigProperties(config);
    return Object.entries(config).map(function (_a) {
        var key = _a[0], value = _a[1];
        return lodash_1.isNil(value)
            ? {
                op: types_1.PatchType.REMOVE,
                path: "/fields/" + fieldKey + "/" + key
            }
            : {
                op: types_1.PatchType.ADD,
                path: "/fields/" + fieldKey + "/" + key,
                value: value
            };
    });
};
exports.updateField = updateField;
var markFieldDeleted = function (fieldKey) {
    validators_1.validateFieldKey(fieldKey);
    return {
        op: types_1.PatchType.ADD,
        path: "/fields/" + fieldKey + "/isDeleted",
        value: true
    };
};
exports.markFieldDeleted = markFieldDeleted;
var restoreField = function (fieldKey) {
    validators_1.validateFieldKey(fieldKey);
    return {
        op: types_1.PatchType.ADD,
        path: "/fields/" + fieldKey + "/isDeleted",
        value: false
    };
};
exports.restoreField = restoreField;
var deleteFieldPermanently = function (fieldKey) {
    validators_1.validateFieldKey(fieldKey);
    return {
        op: types_1.PatchType.REMOVE,
        path: "/fields/" + fieldKey
    };
};
exports.deleteFieldPermanently = deleteFieldPermanently;
//# sourceMappingURL=fields.js.map